module.exports = __webpack_public_path__ + "img/online-trainings-poster.af95a0d5.png";